function initConcealerGuides(root = document) {
  root.querySelectorAll('.md-concealer-guide').forEach(guide => {
    if (guide.dataset.ready) return;
    guide.dataset.ready = 'true';
    const dialog = guide.querySelector('dialog');
    const apply = guide.querySelector('.md-concealer-apply');
    let opener;
    function select(ref) {
      const button = guide.querySelector(`[data-md-shade="${ref}"]`);
      if (!button) return;
      guide.querySelectorAll('[data-md-shade]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      const image = guide.querySelector('.md-concealer-main-face');
      image.src = button.dataset.mdFace;
      image.alt = `Repère de carnation ${button.dataset.mdLabel}`;
      guide.querySelector('.md-concealer-name').textContent = button.dataset.mdLabel;
      const integrated = Boolean(button.dataset.mdUrl);
      guide.querySelector('.md-concealer-state').textContent = integrated ? 'Cette teinte est intégrée à la fiche.' : 'Cette nuance sera proposée prochainement. Vous explorez ici son repère de carnation.';
      apply.hidden = !integrated;
      if (integrated) apply.href = button.dataset.mdUrl;
      else apply.removeAttribute('href');
      const galleryFace = document.querySelector('.md-concealer-portrait-slide img');
      if (galleryFace) { galleryFace.src = button.dataset.mdFace; galleryFace.alt = image.alt; }
    }
    select(guide.dataset.mdCurrent || '05');
    guide.querySelectorAll('[data-md-open-shade]').forEach(button => button.addEventListener('click', () => {
      opener = button; select(button.dataset.mdOpenShade); dialog.showModal();
    }));
    guide.querySelectorAll('[data-md-shade]').forEach(button => button.addEventListener('click', () => select(button.dataset.mdShade)));
    guide.querySelector('.md-concealer-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => opener?.focus());
    apply.addEventListener('click', () => dialog.close());
  });
}
initConcealerGuides();
document.addEventListener('shopify:section:load', event => initConcealerGuides(event.target));
